export const login = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/Login'),
  },
]
